import { useEffect } from 'react';
import {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming,
} from 'react-native-reanimated';
import { durations, stagger as staggerTokens } from '../theme/motion';
import { useReducedMotion } from './useReducedMotion';

interface UseStaggeredEntranceOptions {
  baseDelay?: number;
  step?: number;
  duration?: number;
  translateY?: number;
}

export function useStaggeredEntrance(index: number, options: UseStaggeredEntranceOptions = {}) {
  const {
    baseDelay = staggerTokens.baseDelay,
    step = staggerTokens.step,
    duration = durations.normal,
    translateY = 10,
  } = options;

  const reduced = useReducedMotion();
  const opacity = useSharedValue(reduced ? 1 : 0);
  const ty = useSharedValue(reduced ? 0 : translateY);

  useEffect(() => {
    if (reduced) {
      opacity.value = 1;
      ty.value = 0;
      return;
    }
    const delay = staggerTokens.delay(index, baseDelay, step);
    const easing = Easing.bezier(0.16, 1, 0.3, 1);
    opacity.value = withDelay(delay, withTiming(1, { duration, easing }));
    ty.value = withDelay(delay, withTiming(0, { duration, easing }));
  }, [index, reduced, baseDelay, step, duration, opacity, ty]);

  const style = useAnimatedStyle(() => ({
    opacity: opacity.value,
    transform: [{ translateY: ty.value }],
  }));

  return { style };
}
